import React from 'react';
import './loading.css';

const Loading = () => {
  return (
    <div>
      <main className='mainLoader'>
      <div className="loader"></div>
      </main>
    </div>
  );
}

export default Loading;
